import React, { useState, useEffect } from "react"
import "./Admin.scss"
import { useHistory } from "react-router"
import { useSelector } from "react-redux"
import { centerAdminMenus, systemAdminMenus } from "./adminMenus"
import { MocUserRole } from "../../core/services/models/Enums"


function Admin() {
  const history = useHistory()
  const userRole = useSelector((state: any) => state?.user?.role)
  const userDetail = useSelector((state: any) => state?.user?.userDetail)
  const [adminBlocks, setAdminBlocks] = useState<any>();
  const readOnly = useSelector((state: any) => state?.user);
  console.log(readOnly, "Read only mode");


  useEffect(() => {
    if (userRole) {
      setAdminBlocks(
        userRole === MocUserRole.SYSTEM_ADMIN || userRole === MocUserRole.OPERATIONS
          ? systemAdminMenus
          : centerAdminMenus
      )

    }
  }, [userRole])



  return (
    <div className="admin-wrapper">
      <div className="admin-heading">
        Welcome Back !!-
        {userRole === MocUserRole.CENTER_ADMIN
          ? "Center Admin"
          : userRole === MocUserRole.SYSTEM_ADMIN
            ? "System Admin"
            : "Operations"}
        - {userDetail?.name}
      </div>

      <div className="admin-containers">
        <div className="row rowContainer col-12 m-0">
          {adminBlocks?.map((eachBlock: any) => (
            <div
              className="col-3 each-block-card"
              onClick={() => history.push(eachBlock?.url)}
            >
              <div className="admin-image">
                <img
                  src={eachBlock?.image}
                  style={{
                    width: "64px",
                    height: "64px",
                    zIndex: "2",
                    marginTop: "4px",
                  }}
                  alt=""
                />
              </div>
              <div className="admin-text">{eachBlock?.name}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
export default Admin
